import React from 'react';
import { StyledSpinner } from './Spinner.styles';
import LoadingSpinner from '../../assets/images/loader.gif';

const Spinner = ({ src, width, height }) => {
  return <StyledSpinner src={src || LoadingSpinner} $width={width} $height={height} />;
};

export default Spinner;
